import React from "react";
import SectionHeading from "../ui/SectionHeading";

const OfficeLocations = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Our Office Locations"
          subtitle="Visit us at any of our convenient office locations in Dhaka."
          center
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-12">
          <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300">
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Mirpur Office
              </h3>
              <p className="text-gray-600 mb-4">
                888/1, Haji Ashraf Ali Super Market, East Shewrapara-Mirpur,
                Dhaka-1216
              </p>
            </div>
            <div className="h-80 w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.7279366430966!2d90.37495031498095!3d23.79130188456661!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c0d6f6b8c2ff%3A0x3b138861ee9c8c30!2sEast%20Shewrapara%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1629878765544!5m2!1sen!2sbd"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Mirpur Office Location"
              ></iframe>
            </div>
          </div>
          <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300">
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Kakrail Office
              </h3>
              <p className="text-gray-600 mb-4">
                Room # 11, (3rd Floor), 74 Bhuiyan Mension, Kakrail, Dhaka-1000
              </p>
            </div>
            <div className="h-80 w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.2608666780206!2d90.40676091498!3d23.734747284599128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b85c656315d3%3A0x8cf5193469c92ce9!2sKakrail%2C%20Dhaka%201000!5e0!3m2!1sen!2sbd!4v1629878542763!5m2!1sen!2sbd"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Kakrail Office Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfficeLocations;
